import type { MentionOptions } from '@tiptap/extension-mention'
import { ReactRenderer } from '@tiptap/react'
import tippy, { type Instance } from 'tippy.js'

import { MentionList, type MentionItem } from './mentions-list'

export type { MentionItem }

type GetItems = (args: {
  query: string
}) => MentionItem[] | Promise<MentionItem[]>

export function createSuggestion(
  getItems: GetItems,
): MentionOptions['suggestion'] {
  return {
    items: async ({ query }) => {
      return getItems({ query })
    },

    render: () => {
      let component: ReactRenderer
      let popup: Instance[]

      return {
        onStart: (props) => {
          component = new ReactRenderer(MentionList, {
            props,
            editor: props.editor,
          })

          if (!props.clientRect) {
            return
          }

          popup = tippy('body', {
            getReferenceClientRect: props.clientRect as () => DOMRect,
            appendTo: () => document.body,
            content: component.element,
            showOnCreate: true,
            interactive: true,
            trigger: 'manual',
            placement: 'bottom-start',
          })
        },

        onUpdate(props) {
          component.updateProps(props)

          if (!props.clientRect) {
            return
          }

          popup[0]?.setProps({
            getReferenceClientRect: props.clientRect as () => DOMRect,
          })
        },

        onKeyDown(props) {
          if (props.event.key === 'Escape') {
            popup[0]?.hide()
            return true
          }

          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          return (component.ref as any)?.onKeyDown(props) ?? false
        },

        onExit() {
          popup[0]?.destroy()
          component.destroy()
        },
      }
    },
  }
}
